import {TeamGrid, TeamServiceResponse} from '.';
import {TeamMember} from '../member';

interface LocationTeamServiceResponse extends TeamServiceResponse {
	location: string;
}

export class LocationTeamGrid extends TeamGrid {
	constructor(private readonly location: string) {
		super();
	}

	public async load(): Promise<void> {
		const response = await fetch(`/feeds/team?location=${this.location}`);
		const data: LocationTeamServiceResponse = await response.json();

		this.members = data.members.map((member) => new TeamMember(this, member));
		this.sort();
		
		this.elements.heading.innerText = data.location;
		this.elements.grid.innerHTML = '';
		for (const member of this.members) member.render();
	}

	public sort(): void {
		this.members
			.sort((a, b) => a.sortableName.localeCompare(b.sortableName))
			.sort((a, b) => a.getOrder() - b.getOrder());
	}
}
